import { Language } from './language';

export const DRAFT_STATUS = 1;
export const PUBLISHED_STATUS = 2;
export const ENDED_STATUS = 3;

export enum PollType {
  ARRAUN = 0,
  WITH_RESEARCH_UNIT = 1,
}
export class Poll {
    constructor(
      public hash?: string,
      public name?: string,
      public pollCompleteName?: string,
      public status?: number,
      public level?: string,
      public levelHash?: string,
      public startDate?: Date,
      public endDate?: Date,
      public version?: string,
      public startDaysNotification?: number,
      public endDaysNotification?: number,
      public objective?: number,
      public pollType?: PollType,
      public answersCount?: number,
      public url?: string,
      public languages?: Language[],
      public logoUrl?: string,
      public publicName?: string,
      public companyName?: string,
      public expectedCompletionTime?: string
    ) { }

    clone() {
      return new Poll(
        this.hash,
        this.name,
        this.pollCompleteName,
        this.status,
        this.level,
        this.levelHash,
        this.startDate,
        this.endDate,
        this.version,
        this.startDaysNotification,
        this.endDaysNotification,
        this.objective,
        this.pollType,
        this.answersCount,
        this.url,
        this.languages,
        this.logoUrl,
        this.publicName,
        this.companyName,
        this.expectedCompletionTime
      );
    }

    get languageHashes(): string[] {
      return this.languages ? this.languages.map(l => l.hash) : [];
    }

    get isDraft() {
      return this.status === DRAFT_STATUS;
    }

    get isPublished() {
      return this.status === PUBLISHED_STATUS;
    }

    get isEnded() {
      return this.status === ENDED_STATUS;
    }
  }
